export default {
  title: {
    en: 'Welcome to Scentbird!',
  },
  emailSent: {
    en: 'Your order confirmation has been emailed to {email}',
  },
  note: {
    en: `
      <p>You can choose what fragrances to receive each month yourself.</p>
      <p>When you are in the mood for something else&nbsp;&mdash; Scentbird offers makeup, home fragrances and skincare too.</p>
    `,
  },
}
